import React, { useState, useEffect } from "react";
import styles from "./dropdown.module.scss";

const Dropdown = ({ defaultValue, onChange, values }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const close = () => setOpen(!open);
    if(open) {
      window.addEventListener('click', close);
    }

    return () => window.removeEventListener('click', close);
  });

  return (
    <div className={`${styles.dropdown} ${open ? styles.isOpen : ''}`}>
      <div className={styles.dropdown__header}>
        <button className={styles.dropdown__selected} onClick={() => {setOpen(!open)}}>
          {defaultValue.charAt(0).toUpperCase() + defaultValue.slice(1)}
          <div className={styles[`dropdown__selected__arrow${open ? '__clicked' : ''}`]}>
          </div>
        </button>
      </div>
      {
        open &&
        <ul className={styles.dropdown__list}>
          {
            values.map(({ path, locale }) => (
              <li
                className={`${styles.dropdown__list__items} ${path === defaultValue ? styles.dropdown__list__itemsSelected : ""}`}
                key={path}
              >
                <button onClick={() => onChange(path)}>
                  {locale}
                </button>
              </li>
            ))
          }
        </ul>
      }
    </div>
  );
};

export default Dropdown;
